<mat-card>
    <mat-card-header class="se-dialog-header">
        <mat-card-title>
            <h4 translate>{{ data.header }}</h4>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="grid-wrapper">
            <ag-grid-angular
                #datagrid
                class="worklist-grid"
                [gridOptions]="gridOptions"
                [rowData]="items$ | async"
                [loading]="false"
                [modules]="agGridModuls"
                [theme]="agGridTheme"
            >
            </ag-grid-angular>

            @if (loading) {
                <div class="loading-overlay">
                    <mat-spinner diameter="50"></mat-spinner>
                </div>
            }
        </div>

        <div class="error-message mat-body-medium">
            {{ errorMessage }}
        </div>
    </mat-card-content>

    <mat-card-actions align="end">
        <button mat-button [class.remove-exam-part-disabled]="!canRemove()" (click)="onRemove()">
            <p translate>RemoveExam</p>
        </button>
        <button mat-button (click)="onClose()">
            <p translate>Cancel</p>
        </button>
    </mat-card-actions>
</mat-card>
